;(function() {
  'use strict'

  factory.$inject = ["$rootScope", "$location", "$log", "$q", "$filter", "MessageComment", "imageService", "postsResource", "chainService", "userService", "locationService", "edgeService"];
  angular.module('core.services').factory('Message', factory)

  /* @ngInject */
  function factory(
    $rootScope,
    $location,
    $log,
    $q,
    $filter,
    MessageComment,
    imageService,
    postsResource,
    chainService,
    userService,
    locationService,
    edgeService
  ) {
    var log = $log.create('Message')
    var user = userService.get()

    function Message(options) {
      // check chain for initial data

      var chain = chainService.get()

      this.pageId = chain.pageId
      this.linkId = chain.linkId
      this.elementId = chain.elementId
      this.moduleId = chain.moduleId

      // set defaults

      _.defaultsDeep(this, options, Message.Defaults)

      // if new, set creator keys

      if (!this.id) {
        this.creatorId = user.id
        this.creatorUsername = user.username
      }
    }

    Message.Defaults = {
      elementId: null,
      isPublic: false,
      type: 'feedback',
      typeIcon: 'gi gi-chat',
      text: null,
      moodEntry: null,
      moodExit: null,
      imageData: null,
      comments: [],
      state: 'new',
    }

    Message.Types = {
      FEEDBACK: 'feedback',
      IDEA: 'idea',
      COMPLAINT: 'complaint',
      PRAISE: 'praise',
      SUGGESTION: 'suggestion',
      REQUEST: 'request',
      QUESTION: 'question',
    }

    Message.TypeIcons = {
      feedback: 'gi gi-chat',
      idea: 'gi gi-idea',
      complaint: 'gi gi-complaint',
      praise: 'gi gi-praise',
      suggestion: 'gi gi-suggestion',
      request: 'gi gi-request',
      question: 'gi gi-question',
    }

    Message.TypeMessages = {
      feedback: 'some feedback to',
      idea: 'an idea to',
      complaint: 'a complaint to',
      praise: 'some praise to',
      suggestion: 'a suggestion for',
      request: 'a request to',
      question: 'a question to',
    }

    Message.Nps = {
      DEFINITELY: 5,
      PROBABLY: 4,
      MAYBE: 3,
      NO: 2,
      NEVER: 1,
    }

    Message.Moods = {
      VERY_HAPPY: 6,
      HAPPY: 5,
      MEH: 4,
      NEUTRAL: 3,
      ANGRY: 2,
      VERY_ANGRY: 1,
    }

    Message.States = {
      NEW: 'new',
      READ: 'read',
      UNREAD: 'unread',
      CLOSED: 'closed',
    }

    Message.Errors = {
      CONTENT_REQUIRED: 'message requires an image or text',
      SUBJECT_REQUIRED: 'message requires an elementId or pageId',
    }

    Message.Events = {
      CREATED: 'message:created',
      UPDATED: 'message:updated',
    }

    Message.prototype.fromServer = function(data) {
      // transpose server data to our simplified model

      this.id = data.id

      this.elementId = data.subject.id
      this.elementName = data.subject.name

      this.createdAt = data.createdAt
      this.updatedAt = data.updatedAt || data.createdAt // fallback to createdAt so ordering works

      // token is injected manually from the service.getById(id, token)

      this.token = data.token

      this.isPublic = data.visibility === 'public'
      this.type = data.type
      this.text = data.thread[0].content
      this.moodEntry = _.isObject(data.mood) && data.mood.entry
      this.moodExit = _.isObject(data.mood) && data.mood.exit
      this.moodCurrent = this.moodExit || this.moodEntry
      this.imageUrl = data.imageUrl
      this.state = data.state
      this.creatorId = data.creator.id
      this.creatorType = data.creator.type
      this.recipientId = data.recipient.id
      this.recipientUsername = data.recipient.name
      this.userFlagged = data.userFlagged
      this.userUpvoted = data.userUpvoted
      this.totalUpvotes = data.counts.upvotes || 0
      this.accessToken = data.accessToken
      this.emailUserAccessToken = data.emailUserAccessToken

      this.creatorUsername = data.creator.name
      // replace email user garbage username
      if (this.creatorType === 'email') {
        var usingEmailToken =
          this.token && this.token === this.emailUserAccessToken
        this.creatorUsername = usingEmailToken ? 'You' : 'Anonymous'
      }
      // replace subscriber user garbage username
      if (this.creatorType === 'token') {
        var usingAccessToken = this.token && this.token === this.accessToken
        this.creatorUsername = usingAccessToken ? 'You' : this.elementName
      }

      // remove first comment
      data.thread.shift()

      // create all the comments
      this.comments = []
      _.each(
        data.thread,
        function(comment) {
          this.comments.push(new MessageComment(this).fromServer(comment))
        }.bind(this)
      )

      // calculate number of unread comments
      if (this.state === Message.States.UNREAD && user && user.id) {
        var myLastCommentIndex
        _.each(this.comments, function(comment, index) {
          if (comment.userId === user.id) {
            myLastCommentIndex = index
          }
        })
        if (_.isNumber(myLastCommentIndex)) {
          this.unreadComments = this.comments.length - myLastCommentIndex - 1
        } else {
          this.unreadComments = this.comments.length
        }
      } else {
        this.unreadComments = 0
      }

      return this
    }

    Message.prototype.toServer = function() {
      var data = {}

      // convert our local model to server data

      data.subject = {}
      if (this.pageId) {
        data.subject.type = 'page'
        data.subject.id = this.pageId
      }
      if (this.elementId) {
        data.subject.type = 'element'
        data.subject.id = this.elementId
      }
      data.content = this.text || ''
      data.type = this.type
      data.visibility = this.isPublic ? 'public' : 'private'
      data.communityComments = this.isPublic ? true : false
      data.mood = {}
      data.mood.entry = this.moodEntry
      data.mood.exit = this.moodExit
      data.imageUrl = this.imageUrl
      data.location = locationService.latest.position

      return data
    }

    Message.prototype.getErrors = function() {
      var errors = []

      if ((!this.imageData || !this.imageUrl) && !this.text) {
        errors.push(Message.Errors.CONTENT_REQUIRED)
      }
      if (!this.elementId && !this.pageId) {
        errors.push(Message.Errors.SUBJECT_REQUIRED)
      }

      if (errors.length) {
        return errors
      }
    }

    Message.prototype.canShare = function() {
      var isPublic = this.isPublic
      return isPublic
    }

    Message.prototype.canSave = function() {
      return !this.isSaving && !this.getErrors()
    }

    Message.prototype.canFlag = function() {
      var loggedIn = !!user.id
      var notCreator = !this.isCreator()
      var notRecipient = !this.isRecipient()
      return loggedIn && notCreator && notRecipient
    }

    Message.prototype.canUpvote = function() {
      var loggedIn = !!user.id
      return loggedIn
    }

    Message.prototype.isCreator = function() {
      var loggedIn = !!user.id
      return loggedIn && user.id === this.creatorId
    }

    Message.prototype.haveEmailTokenAccess = function() {
      var haveToken = !!this.token
      var tokenMatches = haveToken && this.token === this.emailUserAccessToken
      return tokenMatches
    }

    Message.prototype.canClose = function() {
      // https://www.glowfeed.com/staging/token-message/99a01976-1570-4b6e-b1af-031c80106085?accessToken=e37fe97e5b4320bf198a3e41cfad79d5&email=rofl@mao.com
      var isCreator = this.isCreator()
      var emailTokenAccess = this.haveEmailTokenAccess()
      var notClosed = !this.isClosed()
      return notClosed && (isCreator || emailTokenAccess)
    }

    Message.prototype.isRecipient = function() {
      var loggedIn = !!user.id
      return loggedIn && user.id === this.recipientId
    }

    Message.prototype.isClosed = function() {
      return this.state === Message.States.CLOSED
    }

    Message.prototype.isUnread = function() {
      return this.state === Message.States.UNREAD
    }

    Message.prototype.canComment = function() {
      var loggedIn = !!user.id
      var haveToken = !!this.token
      var notClosed = !this.isClosed()
      var isPublic = this.isPublic
      var isCreator = this.isCreator()
      var isRecipient = this.isRecipient()

      if (haveToken) {
        return notClosed
      }
      return loggedIn && notClosed && (isPublic || isCreator || isRecipient)
    }

    Message.prototype.commentorType = function() {
      if (user.id && user.id === this.creatorId) {
        return this.creatorType
      }
      if (this.token && this.token === this.emailUserAccessToken) {
        return 'email'
      }
      if (this.token && this.token === this.accessToken) {
        return 'subscriber'
      }
    }

    Message.prototype.toggleUpvote = function() {
      var self = this

      // halt if cant upvote

      if (!this.canUpvote()) {
        return
      }

      // disable while loading (boolean is optimistic while loading)

      if (this.userUpvoted === true || this.userUpvoted === false) {
        return
      }

      // upvote

      if (!this.userUpvoted) {
        // optimistic update
        this.userUpvoted = true
        adjustUpvotes(1)

        // create edge

        edgeService.create('upvote', 'post', this.id).then(
          function(edgeId) {
            self.userUpvoted = edgeId
          },
          function() {
            delete self.userUpvoted
            adjustUpvotes(-1)
          }
        )

        // downvote
      } else {
        // optimistic update

        var edgeId = this.userUpvoted
        this.userUpvoted = false
        adjustUpvotes(-1)

        // remove edge

        edgeService.remove(edgeId).then(
          function() {
            delete self.userUpvoted
          },
          function() {
            self.userUpvoted = edgeId
          }
        )
      }

      function adjustUpvotes(amount) {
        self.totalUpvotes = self.totalUpvotes || 0
        self.totalUpvotes += amount
        // deny < 0
        if (self.totalUpvotes < 0) {
          self.totalUpvotes = 0
        }
      }
    }

    Message.prototype.toggleFlag = function() {
      var self = this

      // halt if cant flag

      if (!this.canFlag()) {
        return
      }

      // disable while loading (boolean is optimistic while loading)

      if (this.userFlagged === true || this.userFlagged === false) {
        return
      }

      // flag

      if (!this.userFlagged) {
        // optimistic

        this.userFlagged = true

        // create edge

        edgeService.create('flag', 'post', this.id).then(
          function(edgeId) {
            self.userFlagged = edgeId
          },
          function() {
            delete self.userFlagged
          }
        )

        // unflag
      } else {
        // optimistic

        var edgeId = this.userFlagged
        this.userFlagged = false

        // remove edge

        edgeService.remove(edgeId).then(
          function() {
            delete self.userFlagged
          },
          function() {
            self.userFlagged = edgeId
          }
        )
      }
    }

    Message.prototype.save = function(options) {
      options = options || {}
      var self = this

      return $q(function(resolve, reject) {
        // update isn't implemented (yet)

        if (self.id) {
          log.error('update message not implemented')
          return reject()
        }

        // validate

        var errors = self.getErrors()
        if (errors) {
          log.info('cant save message with errors', errors)
          return reject(errors)
        }

        // stop if already processing

        if (self.isSaving) {
          log.info('save already in progress')
          return reject()
        }

        self.isSaving = true

        // save image (if any) otherwise do save

        if (self.imageData) {
          imageService.upload(self.imageData).then(
            function(imageUrl) {
              self.imageUrl = imageUrl
              doSave()
            },
            function() {
              self.isSaving = false
              reject()
            }
          )
        } else {
          doSave()
        }

        function doSave() {
          var isNew = !self.id
          var action = isNew ? 'create' : 'update'
          var data = self.toServer()

          // add chain header (if any)

          var chain = []
          if (self.linkId) {
            chain.push('link:' + self.linkId)
          }
          if (self.pageId) {
            chain.push('page:' + self.pageId)
          }
          if (self.moduleId) {
            chain.push('module:' + self.moduleId)
          }
          chain = chain.length ? chain.join(',') : null
          if (chain) {
            options.headers = options.headers || {}
            options.headers['X-Glow-Referral-Chain'] = chain
          }

          // send to server

          postsResource[action](data, null, options)
            .success(function(resource, resp) {
              var eventName = isNew
                ? Message.Events.CREATED
                : Message.Events.UPDATED

              // update our id

              if (resp.id) {
                self.id = resp.id
              }

              self.isSaving = false
              resolve(resp)
              $rootScope.$emit(eventName)
            })
            .error(function() {
              self.isSaving = false
              reject()
            })
        }
      })
    }

    Message.prototype.addComment = function(text) {
      var self = this

      return $q(function(resolve, reject) {
        var data = {
          id: self.id,
          comment: text,
        }

        // display comment immediately (optimistic)

        var optimisticComment = {
          createdAt: moment().toISOString(),
          hidden: false,
          text: $filter('escapeHtml')(text),
          userId: user.id,
          username: user.username || 'You',
          creatorType: self.commentorType(),
        }

        self.comments.push(new MessageComment(self, optimisticComment))

        // if token use that, otherwise create normally

        var promise
        if (self.token) {
          promise = postsResource.reply(
            {
              accessToken: self.token,
            },
            data
          )
        } else {
          promise = postsResource.reply(data)
        }

        promise
          .success(function() {
            resolve(self)
            $rootScope.$emit(Message.Events.UPDATED)
          })
          .error(function() {
            // on fail remove optimistic comment

            self.comments.pop()
            reject()
          })
      })
    }

    Message.prototype.markAsRead = function() {
      var self = this

      return $q(function(resolve, reject) {
        // message needs ID to mark as read

        if (!self.id) {
          log.error('cant mark message as read without an ID')
          return reject()
        }

        // must be logged in as creator (no tokens!)

        if (!self.isCreator() && !self.isRecipient()) {
          log.info('cant mark message as read unless logged in as creator')
          return reject()
        }

        // do update

        var data = {
          id: self.id,
          state: Message.States.READ,
        }

        // if token use that, otherwise update normally

        var request
        if (self.token) {
          request = postsResource.updateState({ accessToken: self.token }, data)
        } else {
          request = postsResource.updateState(data)
        }

        request
          .success(function() {
            resolve(this)
            $rootScope.$emit(Message.Events.UPDATED)
          })
          .error(function() {
            reject()
          })
      })
    }

    Message.prototype.close = function(mood) {
      var self = this

      return $q(function(resolve, reject) {
        // message needs an ID to close

        if (!self.id) {
          log.error('cant close message that doesnt have an ID')
          return reject()
        }

        // validate exit mood value

        var isValid
        _.each(Message.Moods, function(value) {
          if (mood === value) {
            isValid = true
          }
        })

        if (!isValid) {
          log.error('close requires a valid mood')
          return reject()
        }

        // close data

        var data = {
          id: self.id,
          mood: { exit: mood },
          accessToken: self.token,
        }

        // if token use that, otherwise update normally

        var request
        if (self.token) {
          request = postsResource.close({ accessToken: self.token }, data)
        } else {
          request = postsResource.close(data)
        }

        request
          .success(function() {
            self.state = Message.States.CLOSED
            resolve(self)
            $rootScope.$emit(Message.Events.UPDATED)
          })
          .error(function() {
            reject()
          })
      })
    }

    return Message
  }
})()
